var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page"},[_c('site-header'),_c('hero-banner',{on:{"search":_vm.onHeroSearch}}),_c('category-nav',{attrs:{"overlap":""},on:{"select":_vm.onCategorySelect,"show-all":_vm.goSearchPage}}),_c('trademark-grid',{ref:"trademarkGrid"}),_c('process-steps'),_c('info-panels'),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }